import { useEffect } from 'react';
import fetchFlags from 'legacy-src/utility/featureFlag/fetchFlags';
import log from 'chameleon/ui-stack/utilities/log';

const useStudentAppcues = ({
  pathname,
  setFeatureFlagAction,
  isStudent,
  search,
  userId,
}) => {
  useEffect(() => {
    setFeatureFlagAction({
      set_student_app_cues: 'off',
    });
    const path = `${pathname}${search}`;
    const attributes = { pathname: path };
    if (isStudent) {
      fetchFlags('set_student_app_cues', userId, attributes)
        .then((featureFlagStatus) => {
          setFeatureFlagAction({
            set_student_app_cues: featureFlagStatus,
          });
        })
        .catch((error) => {
          log('error', error);
        });
    }
  }, [pathname, search]);
  return null;
};

export default useStudentAppcues;
